import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ISupplierProductNote } from '~/types/note/models'

export const {
  getNoteListData: getSupplierProductNoteListData,
  getNoteDataById: getSupplierProductNoteDataById,
  getNoteListDataByParentId: getSupplierProductNoteListDataBySupplierProductId,
} = makeNoteMockData<ISupplierProductNote>({
  entityName: 'supplierProduct',
  storageKeyPrefix: 'supplierProduct',
})
